import Vue from 'vue/dist/vue.esm.js'
InvolvedEmployee =
  template: JST['report_documents/involved_employee']()
  props: ['employee', 'hashKey']
  data: ->
    name: @employee.name
    salary: @employee.stringified_salary
    intensityRate: @employee.intensity_rate
    projectTypes: @employee.project_types || []
    position: @employee.position
    inputName: 'report_document[involved_employees_attributes]'
    deleted: false

  computed:
    projectTypeSelect: ->
      translation = I18n.t('project_types.short')
      keys = Object.keys(translation)
      _.map keys, (key) -> {value: key, label: translation[key]}

  methods:
    markAsDeleted: (e) ->
      e.preventDefault()
      @deleted = true

    nameWithKey: (parameter = null) ->
      if parameter
        "#{@inputName}[#{@hashKey}][#{parameter}]"
      else
        "#{@inputName}[#{@hashKey}]"

    idWithKey: (parameter = null) ->
      inputName = @nameWithKey(parameter)
      inputName[0..-2].
        replace(/\]\[/g, '_').
        replace(/\]/g, '_').
        replace(/\[/g, '_')

Vue.component('involved-employees-block',
  template: JST['report_documents/involved_employees_block']()
  props: ['initialInvolvedEmployees']
  store: KCVS.Stores.InformativeFieldsStore

  mounted: ->
    @addEmployee() if @initialInvolvedEmployees.length > 1

  data: ->
    involvedEmployees: JSON.parse(@initialInvolvedEmployees)
    filterValue: @$store.state.filterValue

  methods:
    handleAddEmployeeClick: (e) ->
      e.preventDefault()
      @addEmployee()

    addEmployee: ->
      @involvedEmployees.push({name: '', position: '', salary: '0.00', intensity_rate: '0.00'})

    randomKey: ->
      _.uniqueId()

  components:
    'involved-employee': InvolvedEmployee
    'informative-tooltip': KCVS.Views.InformativeTooltip
)
